module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "sidebar"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "newsicon"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/ArticleHome"
    }
  }, [_c('p', [_vm._v("创业资讯")])])], 1), _vm._v(" "), _c('div', {
    style: ({
      display: _vm.isTop ? 'none' : 'block'
    }),
    attrs: {
      "id": "scroll-to-top"
    },
    on: {
      "click": function($event) {
        _vm.handleScrollToTop()
      }
    }
  }, [_c('p', [_vm._v("返回顶部")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kehkz"
  }, [_c('a', {
    attrs: {
      "href": "http://finance.qiyewan.com",
      "target": "_blank"
    }
  }, [_c('p', [_vm._v("客户看账")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "scan-qr-code"
    }
  }, [_c('p', [_vm._v("服务号")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "qr-code"
    }
  }, [_c('img', {
    attrs: {
      "src": "//v3.cdn.qiyewan.com/asidema.png",
      "alt": "qrcode"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-d75657f8!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/SideBar.vue
// module id = 1066
// module chunks = 40